export const empTypeHelper=(type) =>{
    if(!type){
        return '';
    }
    const empmap = {
        2: "Staff",
        3: "Student",
        4: "Branch Admin"
    };

    return  empmap[type]|| "Unknown";

}